'use client';

/**
 * Tracks whether the persistent navigation shell (PortalLayout with sidebar +
 * top nav) is already mounted higher in the React tree. Pages detect this via
 * `usePortalShell()` and skip re-rendering the layout — PageTemplate renders
 * only the page-specific content area when a shell is present, producing
 * GitHub-style navigation where the chrome stays stable.
 */

import { createContext, useContext } from 'react';

interface PortalShellContextValue {
  /** Whether the persistent shell is already mounted above this component */
  hasShell: boolean;
}

const PortalShellContext = createContext<PortalShellContextValue>({ hasShell: false });

export const usePortalShell = () => useContext(PortalShellContext);

export { PortalShellContext };
